import React, { useEffect, useRef } from 'react';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { Box } from '@mui/material';

export type MongoDbDashboardProps = {
  dashboardId: string;
  dashboardUrl?: string;
};

export function MongoDbDashboard({
  dashboardId,
  dashboardUrl = 'https://charts.mongodb.com/charts-cnx-saas-stage-wyzhmnw',
}: MongoDbDashboardProps) {
  if (process.env.MONGODB_CHARTS_URL) {
    dashboardUrl = process.env.MONGODB_CHARTS_URL;
  }
  const chartContainer = useRef(null);

  useEffect(() => {
    const sdk = new ChartsEmbedSDK({
      baseUrl: dashboardUrl,
    });

    const dashboard = sdk.createDashboard({
      dashboardId: dashboardId,
      widthMode: 'scale',
      maxDataAge: 60, // refresh in every minute
    });

    if (chartContainer.current) void dashboard.render(chartContainer.current);
  }, [dashboardId, dashboardUrl]);

  return <Box ref={chartContainer} sx={{ height: '90vh' }}></Box>;
}
